import type { ToolId } from "../core/index.js";
import type { ToolDefinition } from "./types.js";

export const TOOLS: readonly ToolDefinition[] = [
  {
    id: "pencil",
    label: "Stift",
    shortcut: "P",
    description: "Pixel mit Vordergrundfarbe zeichnen (P)",
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>`,
  },
  {
    id: "eraser",
    label: "Radierer",
    shortcut: "E",
    description: "Pixel transparent machen (E)",
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21"></path><path d="M22 21H7"></path><path d="m5 11 9 9"></path></svg>`,
  },
  {
    id: "eyedropper",
    label: "Pipette",
    shortcut: "I",
    description: "Farbe von der Leinwand aufnehmen (I)",
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m2 22 1-1h3l9-9"></path><path d="M9 13 14 8"></path><path d="m14 8 2.5-2.5a2.121 2.121 0 0 1 3 3L17 11"></path><path d="m12 6 2 2"></path></svg>`,
  },
];

export class Toolbar {
  private readonly element: HTMLElement;
  private readonly buttons = new Map<ToolId, HTMLButtonElement>();
  private readonly onSelectTool: (id: ToolId) => void;

  constructor(container: HTMLElement, onSelectTool: (id: ToolId) => void) {
    this.element = container;
    this.onSelectTool = onSelectTool;
    this.render();
  }

  private render(): void {
    this.element.innerHTML = "";
    this.element.className = "tool-rail";
    this.element.setAttribute("role", "toolbar");
    this.element.setAttribute("aria-label", "Werkzeuge");

    for (const tool of TOOLS) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "tool-button";
      btn.dataset.toolId = tool.id;
      btn.title = tool.description;
      btn.setAttribute("aria-label", `${tool.label} (${tool.shortcut})`);
      btn.innerHTML = `
        <span class="tool-icon">${tool.icon}</span>
        <span class="tool-label">${tool.label}</span>
        <span class="tool-badge">${tool.shortcut}</span>
      `;
      btn.addEventListener("click", () => {
        this.onSelectTool(tool.id);
      });
      this.buttons.set(tool.id, btn);
      this.element.appendChild(btn);
    }
  }

  public setActiveTool(activeId: ToolId): void {
    for (const [id, btn] of this.buttons) {
      const isActive = id === activeId;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    }
  }
}
